import angular from "angular";

angular.module('ui-sentinel.shipments.latestShipmentTracking', [
    'ui-sentinel.shipments',
    'ui-sentinel.maps',
    'ui-sentinel.shipments.shipmentReportToolItem'
]);
